import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions,jsx-a11y/role-supports-aria-props,eqeqeq */
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import { DropdownMixin } from './dropdownMixin.js';


/**
 * options should be an array of objects, where each child-object is in the format:
 * { value: <value>, hidden: <hidden>, name: <name> }
 */
export const DropdownMenu = createReactClass({
    propTypes: {
        label: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.string,
        ]).isRequired,
        options: PropTypes.array.isRequired,
        select: PropTypes.func.isRequired,
        selectedValue: PropTypes.any.isRequired,
        ariaLabel: PropTypes.string.isRequired,
        mainClass: PropTypes.string,
        optionsClass: PropTypes.string,
    },

    getDefaultProps: function () {
        return {
            mainClass: '',
            optionsClass: 'dropdown-options',
        };
    },

    componentDidUpdate: function (prevProps, prevState) {
        // When the custom dropdown opens, we want to focus the first element in the list for accessibility
        // Using jQuery like this is a little hacky, but seems easier than using refs
        const isOpen = this.state.isOpen;
        if (isOpen && isOpen !== prevState.isOpen) {
            $(`.${this.props.optionsClass} ul li a`)[0].focus();
        }
    },

    mixins: [DropdownMixin, PureRenderMixin],

    toggle: function (event) {
        this.toggleOpen();
        event.preventDefault();
    },

    handleKeyUp: function (event) {
        event.preventDefault();
        // Escape key
        if (event.keyCode === 27) {
            this.toggle();
        }
    },

    render: function () {
        const props = this.props;

        const selectedSortOption = props.options.find(option => option.value == props.selectedValue);
        const selectedText = selectedSortOption.name;
        let options;
        if (this.state.isOpen) {
            options = (
                <div className={'subnav ignore-react-onclickoutside ' + props.optionsClass} style={{ display: 'block' }} onKeyUp={this.handleKeyUp}>
                    <ul>
                        {
                            props.options.filter(option => (!option.hidden || option == selectedSortOption)).map(function (option) {
                                const value = option.value; const name = option.name;
                                return <DropdownOption {...props} key={value} value={value} name={name} description={option.description} />;
                            })
                        }
                    </ul>
                </div>
            );
        }

        return (
            <div className={props.mainClass}>
                {props.label}{' '}
                <a href="#" onClick={this.toggle} role="listbox" aria-haspopup="listbox" aria-label={props.ariaLabel}>
                    {selectedText}<Svg icon="navigatedown" attributes={{ role: 'presentation' }}/>
                </a>
                {options}
            </div>
        );
    },
});

const DropdownOption = createReactClass({
    propTypes: {
        value: PropTypes.any.isRequired,
        selectedValue: PropTypes.any.isRequired,
        select: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        // description is optional, more verbose text to describe the option when the dropdown is open
        description: PropTypes.any,
    },

    mixins: [PureRenderMixin],

    handleClick: function (event) {
        this.props.select(this.props.value);
        event.preventDefault();
    },

    render: function () {
        const props = this.props;
        const selected = props.selectedValue == props.value;
        const className = selected ? 'active' : '';

        return (
            <li className={className} onClick={this.handleClick} aria-selected={selected} role="option">
                <a href="#">{props.description || props.name}</a>
            </li>
        );
    },
});
